function isMacOS() {
  var _a, _b;
  if (navigator.userAgent) {
    return (_b = (_a = navigator.userAgent) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes('mac');
  }
  return false;
}
function isWindowsOS() {
  var _a, _b;
  if (navigator.userAgent) {
    return (_b = (_a = navigator.userAgent) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes('win');
  }
  return false;
}
function isLinuxOS() {
  var _a, _b;
  if (navigator.userAgent) {
    return (_b = (_a = navigator.userAgent) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes('linux');
  }
  return false;
}
function isIOS() {
  var _a;
  if (navigator.userAgent) {
    return ['iphone', 'ipad'].includes((_a = navigator.userAgent) === null || _a === void 0 ? void 0 : _a.toLowerCase());
  }
  return false;
}
function isAndroid() {
  var _a, _b;
  if (navigator.userAgent) {
    return (_b = (_a = navigator.userAgent) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes('android');
  }
  return false;
}
function getKeyForOS() {
  if (isAndroid() || isIOS()) {
    return '';
  }
  if (isMacOS()) {
    return '⌘';
  }
  if (isWindowsOS()) {
    return 'Ctrl';
  }
  if (isLinuxOS()) {
    return 'Ctrl';
  }
  return 'Ctrl';
}
export { getKeyForOS, isAndroid, isIOS, isLinuxOS, isMacOS, isWindowsOS };
//# sourceMappingURL=os.util.js.map
